import React, { FC, useState } from "react";
import Logo from "components/Logo/Logo";
import MenuBar from "components/MenuBar/MenuBar";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import SwitchDarkMode from "components/SwitchDarkMode/SwitchDarkMode";
import SearchModal from "./SearchModal";
import ReactAnimatedWeather from 'react-animated-weather';
import Button from "../Button/Button";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import LangDropdown from "./LangDropdown"
import LogoSvgMobile from "components/Logo/LogoSvg_mobiile"
import LogoSvg from "components/Logo/LogoSvg"
import LogoMobile from "components/Logo/Logo_mobile"
import { BACKEND_URL } from "constants"
import SwitchDarkMode2 from "components/SwitchDarkMode/SwitchDarkMode2"
import {
  AdvertisingProvider,
  AdvertisingSlot,
  logVersionInfo
} from 'react-advertising';

// export interface MainNav1Props {}

const defaults = {
  icon: 'CLEAR_DAY',
  color: 'goldenrod',
  size: 32,
  animate: true
};

const TextButton = ({ onClick, label, activeCategory, style = {} }) => {
  return (
    <button style={{ border: 'none', padding: 0, fontWeight: label === activeCategory ? 700 : 400, ...style}} onClick={onClick}>{label}</button>
  )
} 


const MainNav1 = () => {
  const [hidden,setHidden] = useState(false)
  const params = useParams()
  const { pathname } = useLocation();
  const parts = pathname.substring(1).split('/');
  let { category, subcategory, categoryid,  subcategoryid } = params;
  if (!category) {
    category = parts.length === 2 ? parts[0] : parts[1];
  }

  if (!categoryid) {
    categoryid = parts.length === 2 ? parts[1] : parts[2];
  }

  const showTab = () => {
  setHidden(true);

  requestAnimationFrame(() => {
    const tab = document.getElementById("navigation");
    if (tab) {
      tab.style.display = "flex";
    }
  });
};

  const paths = window.location.pathname.split('/').slice(1);
  return (
    <>
    {/* <div className="mobile-logos"><Logo/></div> */}
    <div><AdvertisingProvider>
              <div style={{backgroundImage:`url(
https://marekwiniarski.publit.io/file/BANER.jpg)`, backgroundSize:"cover",  position: "relative", }} className="image">
                <div style={{ position: "absolute", bottom:"20px"}} className="mobile-nav">
          <Link className="link-font" onClick={showTab} style={{ fontWeight: paths.includes("swiat") ? 700 : 200, color:  paths.includes("swiat") && "red" ,padding:"0px", }} to={`swiat/1`}>ŚWIAT</Link>
        <Link className="link-font"   onClick={showTab}  style={{ fontWeight: paths.includes("kraj") ? 700 : 200, color:  paths.includes("kraj") && "red", padding:"0px" }} to={`kraj/3`}>KRAJ</Link>
        <Link className="link-font"   onClick={showTab} style={{ fontWeight: paths.includes("region") ? 700 : 200, color:  paths.includes("region") && "red", padding:"4px 10px 4px 10px" }} to={`region/5`}>REGION</Link>
         <div className="additional-menu">
         {/* <Link onClick={() => setHidden(false)} className="link-font" to="/horoskop">H O R O S K OP</Link> */}
         {/* <Link onClick={() => setHidden(false)} className="link-font" to="/kuchnia">K U C H N I A</Link>  */}
                  <Link onClick={() => setHidden(false)}className="link-font" to="/zdrowie">ZDROWIE</Link> 
         <Link onClick={() => setHidden(false)}className="link-font" to="/nauka">NAUKA</Link>  
          <Link onClick={() => setHidden(false)}className="link-font" to="/sport">SPORT</Link>   
          <Link onClick={() => setHidden(false)}className="link-font" to="/kultura">KULTURA</Link>   
         {/* <Link onClick={() => setHidden(false)} className="link-font" to="/pogoda">P O G O D A</Link> */}
         <Link onClick={() => setHidden(false)} className="link-font" to="#">WYWIADY EXCLUSIVE</Link>
         {/* <Link onClick={() => setHidden(false)} className="link-font" to="#">SHOWBIZNES</Link> */}
         {/* <Link onClick={() => setHidden(false)} className="link-font" to="/">WYBORY PREZYDENCKIE 2025</Link> */}
         <Link onClick={() => setHidden(false)} className="link-font" to="/gazety">GAZETY</Link>  
         {/* <Link onClick={() => setHidden(false)} className="link-font" to="/filmy">V I D E O</Link>   */}
         </div>
         <div className="menu-responsive">
            <div className="flex items-center lg:hidden">
              <MenuBar />
            </div>
          <div className="flex items-center space-x-4 sm:space-x-10 2xl:space-x-14 mobile-menu">
            <LogoMobile/>
          </div>
          {/* <div className="mobile-logo-down"><Logo/></div> */}
          <div className="search-responsive">
            <SearchModal/>
            <div className="cursor-pointer">
            <a href="/signup"><i class="fa fa-user" aria-hidden="true"></i></a>
            </div>
            <SwitchDarkMode2/>
           </div> 
          </div> 
          </div>
              </div>
              </AdvertisingProvider>
              </div>
    <div className="nc-MainNav1 relative z-10 dark:bg-slate-900 ">
      <div
       className="container"
       >
        <div style={{flexFlow:"column"}} className="flex items-center mobiles-navigation">
          <div className="menu-responsive-2">
            <div className="flex items-center lg:hidden">
              <MenuBar />
            </div>
          <div className="flex items-center space-x-4 sm:space-x-10 2xl:space-x-14 mobile-menu">
            <LogoMobile/>
          </div>
          {/* <div className="mobile-logo-down"><Logo/></div> */}
          <div className="search-responsive">
            <SearchModal/>
            <div className="cursor-pointer">
            <a href="/signup"><i class="fa fa-user" aria-hidden="true"></i></a>
            </div>
            <SwitchDarkMode2/>
           </div> 
          </div>
          <div className="mobile-links">
           <Link className="link-font" style={{ fontWeight: paths.includes("swiat") ? 900 : 200, color:  paths.includes("swiat") && "red", padding:"4px 10px 4px 10px"}} to={`polityka/swiat/1/2`}>Ś W I A T</Link>
        <Link className="link-font"  style={{ fontWeight: paths.includes("kraj") ? 900 : 200, color:  paths.includes("kraj") && "red", padding:"4px 10px 4px 10px", }} to={`polityka/kraj/3/2`}>K R A J</Link>
        <Link className="link-font" style={{ fontWeight: paths.includes("region") ? 900 : 200, color:  paths.includes("region") &&  "red", padding:"4px 10px 4px 10px" }} to={`polityka/region/5/2`}>R E G I O N</Link>
           </div>
          <div id="navigation" className="hidden-nav" style={{position:"absolute", height:"24px", width:"100%", display: "none",  justifyContent:"center", color:"black", right:"1px", gap:"25px", alignItems:"center"}}>
                { category !== undefined && <div className="animation-nav" style={{width:"100%", display:'flex', justifyContent:"center", color:"black", gap:"20px", alignItems:"center"}}>
                <Link style={{color: parts[0] === "polityka" && "red" }} 
                to={`/polityka/${category}/${categoryid}/2` }
         >P O L I T Y KA</Link>
         <Link style={{color: parts[0] === "gospodarka" && "red" }} 
                to={`/gospodarka/${category}/${categoryid}/1`}>G O S P O D A R K A</Link>

          <Link style={{color: parts[0] === "spoleczenstwo" && "red" }} 
                to={`/spoleczenstwo/${category}/${categoryid}/3`}>S P O Ł E C Z E Ń S T W O</Link>

          <Link style={{color: parts[0] === "sport" && "red" }} 
                to={`/sport/${category}/${categoryid}/4`}>S P O R T</Link>
          <Link style={{color: parts[0] === "zdrowie" && "red" }} 
                to={`/zdrowie/${category}/${categoryid}/6`}>Z D R O W I E</Link>
            <Link style={{color: parts[0] === "kultura" && "red" }} 
                to={`/kultura/${category}/${categoryid}/7`}>K U L T U R A</Link>
            <Link style={{color: parts[0] === "rozrywka" && "red" }} 
                to={`/rozrywka/${category}/${categoryid}/8`}>R O Z R Y W K A</Link>


                  {window.location.pathname.split("/")[parts.length === 2 ? 1: 2]  == "region" && <Link style={{color: parts[0] === "aktualnosci" ? "red": "black" }} 
                to={`/aktualnosci/${category}/${categoryid}/5`}>A K T U A L N O Ś C I</Link>}
                </div>}
          </div>
          {/* </div> */}
          </div>
        </div>
      </div>
      </>
  );
};

export default MainNav1;